import { render, staticRenderFns } from "./QuickBuy.vue?vue&type=template&id=1cb38378&"
import script from "./QuickBuy.vue?vue&type=script&lang=js&"
export * from "./QuickBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cb38378')) {
      api.createRecord('1cb38378', component.options)
    } else {
      api.reload('1cb38378', component.options)
    }
    module.hot.accept("./QuickBuy.vue?vue&type=template&id=1cb38378&", function () {
      api.rerender('1cb38378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/QuickBuy.vue"
export default component.exports